export const SPARE_PART_DAMAGED_NO = 'NO';
export const SPARE_PART_DAMAGED_SI_ACEPTADO = 'SI, ACEPTADO';
export const SPARE_PART_DAMAGED_SI_NO_ACEPTADO = 'SI, NO ACEPTADO';
export const SPARE_PART_DAMAGED_SI_CONSULTADO_TALLER = 'SI, CONSULTADO TALLER';
export const SPARE_PART_DAMAGED_PENDIENTE_APROBACION = 'PENDIENTE APROBACION ALDANA';

export const SPARE_PART_DAMAGED_STATES = [
  SPARE_PART_DAMAGED_NO,
  SPARE_PART_DAMAGED_SI_ACEPTADO,
  SPARE_PART_DAMAGED_SI_NO_ACEPTADO,
  SPARE_PART_DAMAGED_SI_CONSULTADO_TALLER,
  SPARE_PART_DAMAGED_PENDIENTE_APROBACION
] as const;

export type SparePartDamagedState = (typeof SPARE_PART_DAMAGED_STATES)[number];

export const SPARE_PART_DAMAGED_OPTIONS: ReadonlyArray<{ value: SparePartDamagedState; label: string }> = [
  { value: SPARE_PART_DAMAGED_NO, label: 'No' },
  { value: SPARE_PART_DAMAGED_SI_ACEPTADO, label: 'Sí, aceptado' },
  { value: SPARE_PART_DAMAGED_SI_NO_ACEPTADO, label: 'Sí, no aceptado' },
  { value: SPARE_PART_DAMAGED_SI_CONSULTADO_TALLER, label: 'Sí, consultado taller' },
  { value: SPARE_PART_DAMAGED_PENDIENTE_APROBACION, label: 'Pendiente aprobación Aldana' }
];
